import { render, staticRenderFns } from "./r-trigger-generic.vue?vue&type=template&id=6e948fc5&scoped=true"
import script from "./r-trigger-generic.vue?vue&type=script&lang=js"
export * from "./r-trigger-generic.vue?vue&type=script&lang=js"
import style0 from "./r-trigger-generic.vue?vue&type=style&index=0&id=6e948fc5&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e948fc5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e948fc5')) {
      api.createRecord('6e948fc5', component.options)
    } else {
      api.reload('6e948fc5', component.options)
    }
    module.hot.accept("./r-trigger-generic.vue?vue&type=template&id=6e948fc5&scoped=true", function () {
      api.rerender('6e948fc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trigger/r-trigger-generic.vue"
export default component.exports